<template>
  <div class="rightBox_2">
    <div class="right_box">
      <div class="right_box_1">
        <miniMap></miniMap>
      </div>
      <div class="bgc right_box_2">
        <el-table :data="regionList"
                  @cell-click="handle"
                  height="100%"
                  :span-method="cellMerge"
                  table-layout='auto'
                  border>
          <el-table-column prop="region"
                           label="市"
                           width="100%">
          </el-table-column>
          <el-table-column prop="region_burg"
                           label="乡、村">
            <template scope="scope">
              <div>{{ scope.row.region_burg }}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog :title='`${pathName}-${dialogName}`'
               :visible.sync="dialogVisible"
               width="80%"
               custom-class="dialog_class"
               :append-to-body='true'>
      <!-- <div class="dialog_nr">
        123
        <div class="a">123</div>
      </div> -->
    </el-dialog>
  </div>
</template>

<script>
import miniMap from '@/components/miniMap.vue'
import bus from '../utils/bus.js'

export default {
  components: {
    miniMap
  },
  data () {
    return {
      regionList: [],
      spanArr: [],
      pos: '',
      dialogName: '',
      pathName: '',
      dialogVisible: false,
      a: 0
    }
  },
  created () {

  },
  mounted () {
    // this.getSpanArr(this.tableData)
    this.getRegionList()
    this.getImg(0)
  },
  methods: {
    // 获取表格数据
    getRegionList () {
      this.data = JSON.parse(localStorage.getItem("date"))
      // console.log(this.data);
      this.data.forEach((item, index1) => {
        item.slist.forEach((item2, index2) => {
          this.regionList.push({
            region: item.region,
            region_burg: item2.region_burg,
            ...item2
          }
          )
        })
      });
      console.log(this.regionList);
      bus.$emit('regionList', this.regionList)

      //清空合并坐标
      this.spanArr = []
      this.pos = 0

      this.getSpanArr(this.regionList);
    },

    getSpanArr (data) {
      for (var i = 0; i < data.length; i++)
      {
        if (i === 0)
        {
          this.spanArr.push(1);
          this.pos = 0
        } else
        {
          // 判断当前元素与上一个元素是否相同
          if (data[i].region === data[i - 1].region)
          {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else
          {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
      }
    },
    cellMerge ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0)
      {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        }
      }
    },

    handle (row, column, event, cell) {
      console.log(row)
      this.getImg(row.city_id)

      bus.$emit('mapBus', row)
      // console.log(column)
      // console.log(event)
      // console.log(cell)
    },

    getImg (city_id) {
      bus.$emit('city_id', city_id)
    }
  },
}
</script>

<style lang="less" scoped>
.right_box {
  position: absolute;
  top: 0;
  right: 0;
  width: 25%;
  height: 100vh;

  .right_box_1 {
    height: 40vh;
  }

  .right_box_2 {
    width: 98%;
    height: 55vh;

    /deep/ .el-table {
      padding: 0;
      font-size: calc(100vw * 12 / 1920);
      cursor: pointer;
    }

    /deep/ .el-table th {
      font-size: calc(100vw * 16 / 1920);
      font-weight: 700;
      background-color: #ccffff;
    }

    /deep/ .el-table tr,
    .el-table {
      background-color: rgba(255, 255, 255, 0.322);
    }

    /deep/ .el-table__cell {
      padding: 2px 0;
      text-align: center;
    }
  }
}
</style>